export enum ValidationLockFilter {
  ALL_PROJECTS = 'ALL_PROJECTS',
  LOCKED = 'LOCKED',
  UNLOCKED = 'UNLOCKED',
}

export const validationLockFilterToLabel: { [value: string]: string } = {
  [ValidationLockFilter.ALL_PROJECTS]: 'All Projects',
  [ValidationLockFilter.LOCKED]: 'Locked',
  [ValidationLockFilter.UNLOCKED]: 'Unlocked',
};
